/**
 * Role Switcher component script file
 *
 * @package    Containers
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import CustomSelect from 'Common/CustomSelect';

import { FormattedMessage } from 'react-intl';

import { changeRole } from 'Actions/auth';

@connect(
    store => ({
        user: store.auth.user,
    }),
    dispatch => ({
        changeRole: role => dispatch(changeRole(role)),
        openDefaultPage: () => dispatch(push('/')),
    })
)
export default class RoleSwitcher extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        user: PropTypes.object.isRequired,
        changeRole: PropTypes.func.isRequired,
        openDefaultPage: PropTypes.func.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * Handle change role
     *
     * @param value
     */
    handleChange = value => {
        const {
            changeRole,
            openDefaultPage,
            user: { roles, activeRole },
        } = this.props;

        if(value !== activeRole.role) {
            openDefaultPage();
            changeRole(roles.find(item => item.role === value));
        }
    };

    /**
     *
     * @returns {*}
     */
    render() {
        const {
            user: { roles, activeRole },
        } = this.props;

        const options = roles.map(item => ({ value: item.role, label: <FormattedMessage id={`role.${item.role}`} /> }));

        return (
            <CustomSelect
                disabled={options.length < 2}
                disableUnderline
                value={activeRole.role}
                title={this.context.intl.formatMessage({ id: `role.${activeRole.role}` })}
                onChange={this.handleChange}
                options={options}
                className={'mm-role-switcher-select' + (options.length < 2 ? ' mm-role-switcher-select-disabled' : '')}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/RoleSwitcher/RoleSwitcher.jsx